import { Component, Input } from '@angular/core';
import { MatFabButton } from '@angular/material/button';
import { NgClass, NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'au-round-button',
	templateUrl: './au-round-button.component.html',
	styleUrls: ['./au-round-button.component.scss'],
	imports: [MatFabButton, NgClass, NgStyle, MatIcon],
})
export class AuRoundButtonComponent {
	@Input()
	size: number;

	@Input()
	icon: string;

	@Input()
	opened = false;

	@Input() color: 'primary';
}
